import React, { useCallback } from 'react';

import classNames from 'classnames';
import * as fromProjects from 'store/Projects';

import { a } from '@react-spring/web';
import { useIntersect } from 'hooks/useIntersect';
import { useAnimateInSpring } from 'hooks/useAnimateInSpring';
import { initialOffset } from 'components/Animations/SpringProperties/SpringProperties';

import { AngledHorizontal } from './AngledHorizontal/AngledHorizontal';

interface IProps {
  animationReady: boolean;
  bodyContent: object;
}

export const MassiveScrollingImage: React.FC<IProps> = ({ animationReady, ...props }) => {
  const bodyContent: fromProjects.IContentMassiveScrollingImageSection = props.bodyContent as fromProjects.IContentMassiveScrollingImageSection;

  const [inViewRef, inView] = useIntersect({
    startObserving: animationReady,
    rootMargin: "-150px 0px -150px 0px",
  });

  const animateInSpring = useAnimateInSpring(inView);

  const getComponent = useCallback(() => {
    const itemVariation: fromProjects.IContentMassiveScrollingImageVariations = bodyContent.variation;

    const listComponentCommonProps = {
      animationReady: inView,
      content: bodyContent.content,
    };

    if (itemVariation === 'angledHorizontal') {
      return <AngledHorizontal {...listComponentCommonProps} />;
    }
  }, [inView]);

  const imageWrapperStyles = {
    opacity: animateInSpring.active,
    transform: animateInSpring.active.to(x => `translateY(calc(${initialOffset(x)}))`),
  };

  return (
    <a.div
      ref={inViewRef}
      className={classNames(
        'massiveScrollingImageWrapper',
        bodyContent.variation,
      )}
      style={imageWrapperStyles}
    >
      <div className='content-wrapper'>
        {getComponent()}
      </div>
    </a.div>
  );
};

